<script>
	// visual components
	import FishFilled from "../components/FishFilled.svelte";
	import FishOutlined from "../components/FishOutlined.svelte";

	// business logic
	import { isPortraitScreen, shareSectionHidden } from '../js/model/stores';
	import { onMount } from 'svelte';

	let _inputNameFirst;
	let _inputEmailFirst;
	let _inputPhoneHoneypot;
	let _inputText;
	let _submitButton;
	let portrait;
	let hidden = true;

	export let route;

	function darkenTextArea(event) {
		event.target.style.color = 'var(--color-grey)';
	}

	function recalculateTextareaRows() {
		if (hidden) {
			return;
		}
		setTimeout(() => {
			_inputText.setAttribute('rows', 1);
			const startScrollHeight = _inputText.scrollHeight;
			const style = window.getComputedStyle(_inputText, null);
			const padding = parseInt(style.getPropertyValue("padding-top")) + parseInt(style.getPropertyValue("padding-bottom"));
			while (_inputText.offsetHeight - padding <= startScrollHeight) {
				_inputText.setAttribute('rows', parseInt(_inputText.getAttribute('rows')) + 1);
			}
		}, 1500);
	}

	function checkIfSubmitPossible() {
		if (_inputNameFirst.value === '' || _inputEmailFirst.value === '' || _inputText.value === '') {
			_submitButton.classList.remove('submit--allowed');
			return;
		}
		_submitButton.classList.add('submit--allowed');
	}

	onMount(() => {
		_submitButton.classList.remove('submit--allowed');

		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});

		shareSectionHidden.subscribe((state) => {
			hidden = state;
		});

		window.addEventListener('resize', recalculateTextareaRows);

		recalculateTextareaRows();

		var formElement = document.querySelector("form#share");
		console.log(formElement);
		formElement.addEventListener('submit', function (ev) {
			ev.preventDefault();

			var request = new XMLHttpRequest();

			request.onload = () => {
				if (request.status >= 200 && request.status < 300) {
					// parse JSON
					const response = JSON.parse(request.responseText);
					console.log(response);
				}
			};

			request.open("POST", "https://api.wirunterstuetzenchemnitz.de/share");
			request.setRequestHeader("Content-Type", "application/json;charset=UTF-8");
			var object = {};
			new FormData(formElement).forEach((value, key) => {
				// Reflect.has in favor of: object.hasOwnProperty(key)
				if (!Reflect.has(object, key)) {
					object[key] = value;
					return;
				}
				if (!Array.isArray(object[key])) {
					object[key] = [object[key]];
				}
				object[key].push(value);
			});
			var json = JSON.stringify(object);
			request.send(json);
		}, false);
	});
</script>

<style>
	section {
		display: block;
	}

	section.hidden {
		display: none;
	}

	:global(section.hidden + section) {
		margin-top: 6em;
	}

	.text {
		width: 50%;
		padding-bottom: 4vh;
		padding-left: 24%;
		position: relative;
		z-index: 20;
	}

	.portrait .text {
		width: 80%;
		padding: 0 0 15vh 0;
		margin: 0 auto;
	}

	.input input {
		border-radius: 2em;
		text-align: center;
		min-width: 23vw;
	}

	.portrait .input input {
		width: 80vw;
	}

	.input input[type=text] {
		margin: 0 0 1.2em 0;
	}

	.input input[type=text],
	textarea {
		border: 2px solid var(--color-blue);
		color: var(--color-grey);
		font-size: var(--font-h1-size);
	}

	.input input[type=text]::placeholder {
		color: var(--color-grey-alpha);
	}

	.input input[type=submit] {
		border: none;
		background-color: var(--color-light-magenta);
		color: white;
		text-transform: uppercase;
		font-weight: 700;
		pointer-events: none;
	}

	.shares {
		width: 80%;
		margin-left: 10%;
		display: flex;
		flex-wrap: wrap;
		gap: 5vw;
	}

	.shares .share {
		width: 100%;
		flex: 1;
		margin-bottom: unset;
	}

	.portrait .shares .share {
		margin-bottom: 3em;
	}

	.portrait .shares .share:last-of-type {
		margin-bottom: unset;
	}

	textarea {
		width: 80%;
		border: 2px solid #5a97c3;
		border-radius: 2em;
		text-align: center;
		padding: 1vw 2vw 2vw;
		margin-bottom: 1em;
		color: var(--color-grey-alpha);
	}

	.input:nth-child(7) {
		height: 0;
		position: absolute;
		width: 100%;
		z-index: 1;
	}

	.input:nth-child(8) {
		position: relative;
		z-index: 5;
	}

	.input:nth-child(8) input {
		width: 20vw;
		min-width: 200px;
	}

	.input input[type=tel] {
		position: absolute;
		left: -100vw;
	}

	.input input[type=submit].submit--allowed {
		background-color: var(--color-magenta);
		cursor: pointer;
		pointer-events: all;
	}

	:global(section.confirmed) {
		padding-top: calc((215.1 / 1440) * 110vw);
		margin-top: calc((215.1 / 1440) * -110vw);
		background-color: var(--color-light-blue);
		padding-bottom: 10vh;
		margin-bottom: -10vh;
	}

	:global(.portrait #fish-outlined-3) {
		width: 5em;
		height: auto;
		left: 83vw;
		top: 5vh;
	}

	:global(.portrait #fish-outlined-4) {
		width: 5em;
		height: auto;
		left: 35vw;
		top: 80vh;
	}

	:global(.portrait #fish-filled-3) {
		top: 52vh;
		left: 5vw;
	}

	:global(.portrait #fish-filled-4) {
		width: 6em;
		height: auto;
		top: 111vh;
		left: 70vw;
	}

	.anchor {
		display: block;
		transform: translateY(-5em);
	}
</style>

<section class:portrait class:hidden class="{route}">
	<span class="anchor" id="share"></span>
	<div class="content">
		<h2>Sag es weiter!</h2>
		<div class="text">Du kennst jemanden, der vielleicht noch nichts mit der Bewerbung anfangen kann und findest, das sollte sich ändern? Dann hast du hier die Möglichkeit dazu. Sag es bis zu drei Personen weiter und unterstütze uns dabei, Chemnitz bunter zu machen.</div>
		<FishFilled id="fish-filled-3" size="5em" direction="ltr" left="20vw" top="4vh" speedMultiplier="0.3"/>
		<FishOutlined id="fish-outlined-3" size="5em" direction="rtl" left="93vw" top="4vh" speedMultiplier="0.2"/>
		<FishOutlined id="fish-outlined-4" size="4em" direction="ltr" left="3vw" top="15vh" speedMultiplier="0.3"/>
		<FishFilled id="fish-filled-4" size="7em" direction="rtl" left="90vw" top="60vh" speedMultiplier="0.4"/>
		<form id="share">
			<div class="shares">
				<div class="share">
					<div class="input"><input type="text" name="names" bind:this={_inputNameFirst} on:change={checkIfSubmitPossible} on:keyup={checkIfSubmitPossible} required placeholder="Name 1"/></div>
					<div class="input"><input type="text" name="emails" bind:this={_inputEmailFirst} on:change={checkIfSubmitPossible} on:keyup={checkIfSubmitPossible} required placeholder="E-Mail 1"/></div>
				</div>
				<div class="share">
					<div class="input"><input type="text" name="names" placeholder="Name 2"/></div>
					<div class="input"><input type="text" name="emails" placeholder="E-Mail 2"/></div>
				</div>
				<div class="share">
					<div class="input"><input type="text" name="names" placeholder="Name 3"/></div>
					<div class="input"><input type="text" name="emails" placeholder="E-Mail 3"/></div>
				</div>
			</div>
			<div class="share_text">
			<textarea name="text" bind:this={_inputText} on:change={checkIfSubmitPossible} on:keyup={checkIfSubmitPossible} on:click|once={darkenTextArea} rows="3">Hey!
	Schau mal, was ich gefunden habe. Findest du die Bewerbung zur Kulturhauptstadt 2025 auch cool? Dann unterstütze sie doch auf dieser Seite.</textarea>
			</div>
			<div class="input"><input type="tel" name="phones" bind:this={_inputPhoneHoneypot} placeholder="Telefonnummer"/></div>
			<div class="input"><input type="submit" class="cta submit--allowed" bind:this={_submitButton} value="Weitersagen"/></div>
		</form>
    </div>
</section>
